import './ForgotPassword.css';

import React, { Component } from 'react';
import Services from '../../tools/Services';

import Dialog           from '@material-ui/core/Dialog';
import Button           from '@material-ui/core/Button';
import TextField        from '@material-ui/core/TextField';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';


export default class ForgotPassword extends Component {
    state = {
            open: false,
            email: '',
            error: '',
        }

    async sendEmailPwd() {
        let email = this.state.email;
        // Post
        let res = await Services.post('send_email_password', {
            email
        });

        // Error
        if (res.status !== 'success') {
            // Check if its a server error
            if (res.error !== 'ERROR_EMAIL_PWD_INCORRECT') {
                this.setState({
                    error: res.error
                });
                return;
            }

            // Invalid email or password
            this.setState({
                error: 'Invalid e-mail or password'
            }); // TODO SR
            return;
        }
    }

    async sendUsernamePwd() {
        let email = this.state.email;
        // Post
        let res = await Services.post('send_email_password', {
            username: email
        });

        // Error
        if (res.status !== 'success') {
            // Check if its a server error
            if (res.error !== 'ERROR_EMAIL_PWD_INCORRECT') {
                this.setState({
                    error: res.error
                });
                return;
            }

            // Invalid email or password
            this.setState({
                error: 'Invalid e-mail or password'
            }); // TODO SR
            return;
        }
    }

    isEmailAddress(emailAddress) {
        let re = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return re.test(emailAddress);
    };

    // Handles
    handleClose = (e) => {
        // Handle close when save button is pressed
        this.setState({
            open: false
        });
        this.props.onClose();
    };

    handleChange = (e) => {
        this.setState({
            email: e.target.value
        });
    }

    handleClick = (e) => {
        if (this.state.email.length === 0)
            return this.setState({
                error: 'Invalid e-mail/username'
            }); // TODO SR
        if (this.isEmailAddress(this.state.email))
            return this.sendEmailPwd();
        return this.sendUsernamePwd();
    }

    render() {
            let { email, error } = this.state;
            return (
                <Dialog onClose={this.handleClose} open={this.props.open}>
                    <div className='MuiDialogTitle-root close' >
                        <h2>Forgot your password?</h2>
                        <span className='mdi mdi-close' onClick={this.handleClose}></span>
                    </div>
                    <MuiDialogContent>
                        <h3>Please write your email or your username (for administrators only) to receive a new password:</h3>
                        <TextField name='email' type='text' value={email} onChange={this.handleChange} placeholder='Enter your e-mail or username' id='username' className='loginUser' />
                        <h3 >{error}</h3>
                    </MuiDialogContent>
                    <MuiDialogActions>
                        <Button onClick={this.handleClose}>CANCEL</Button>
                        <Button className='saveButton' onClick={this.handleClick}>SAVE</Button>
                    </MuiDialogActions>
                </Dialog>
            )
    }
}